var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgConditionalIndicator = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 10,
  viewBox: "2.66 2.53 5.7 5.7"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.893 2.526c.808 0 1.656.36 2.208.928l-.734.896c-.384-.44-.936-.728-1.456-.728-.96 0-1.705.744-1.705 1.72S4.95 7.07 5.91 7.07c.503 0 1.055-.256 1.455-.656l.744.808c-.594.608-1.45 1-2.266 1-1.672 0-2.936-1.24-2.936-2.864 0-1.616 1.287-2.832 2.983-2.832z"
})));
export default SvgConditionalIndicator;